/**
 * @author Sarah Nouh
 * @copyright Copyright 2020 by Radivision Inc., CA, USA. All Rights Reserved.
 * @Date: 2018-07-16 7:00
 * @description Implementation of the five by two grid.
 * @filename five-by-two-grid.tsx
 */
import React from "react";
import LazyLoad from 'react-lazyload';
import ProgressiveImage from "react-progressive-image";
import { GridContent } from "../../component-configuration/grid-content";

/**
 * The URL of the on-star image.
 *
 * @type {string}
 */
const ON_STAR_URL: string = require("../../../static/on-star.png");

/**
 *  A React component that renders a 'five by two grid'.
 *
 * @export
 * @class FiveByTwoGrid
 * @extends {React.Component<GridContent>}
 */
export class FiveByTwoGrid extends React.Component<GridContent> {
  /**
   * Constructor.
   *
   * @param {GridContent} props The props of the component.
   */
  constructor(props: GridContent) {
    super(props);
  }

  /**
   * Returns a ReactNode containing the rendered component.
   *
   * @returns {React.ReactNode} The ReactNode containing the rendered component.
   */
  render() {
    return (
      <div className="container-fluid five-by-two-grid">
        <div className="row">
          <div className="on-curated">
            <img loading="lazy" src={ON_STAR_URL} alt="" />
            <span className="text-uppercase">curated</span>
          </div>
          <h3 className="title text-uppercase">{this.props.title}</h3>
        </div>
        <div className="row">
          {this.props.companiesLogos.map((item, index) => {
            return (
              <div className="col-sm-2" key={index.toString()}>
                <LazyLoad once={true} >
<ProgressiveImage
                  src={`${item}?wip=50`}
                  srcSetData={{
                    srcSet: `${item}?wip=100 576w, ${item}?wip=200 768w, ${item}?wip=300 992w, ${item}?wip=400 1200w`,
                    sizes: "(max-width: 2000px) 100vw, 2000px"
                  }}
                  placeholder={`${item}?wip=10`}
                >
                  {(src: any, LOADING: any, srcSetData: any) => (
                    <img loading="lazy"
                      className="grid-image"
                      src={src}
                      srcSet={srcSetData.srcSet}
                      sizes={srcSetData.sizes}
                    />
                  )}
                </ProgressiveImage>
      </LazyLoad>

              </div>
            );
          })}
        </div>
        <div className="row">
          <p className="description">{this.props.description}</p>
          <span className="resources-count">{this.props.resourcesCount}</span>
        </div>
      </div>
    );
  }
}
